import { createTV } from "tailwind-variants";
import { twExtendedConfig } from "./tw-merge.config.js";
const tv = createTV({
  twMergeConfig: {
    extend: {
      ...twExtendedConfig
    }
  }
});
export {
  tv
};
